<template>
  <div>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="zip_code">Zip code</label>
        <input
          id="zip_code"
          v-model="formFields.zip_code"
          type="text"
          required
        >
        <p class="small">
          *The zip code will be used to filter your feed.
        </p>
        <div
          v-if="formErrors.zip_code !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.zip_code[0] }}
        </div>
      </div>

      <div class="form-group">
        <label>Distance</label>
        <select
          v-model="formFields.distance"
          required
        >
          <option value="25">
            Within 25 miles
          </option>
          <option value="50">
            Within 50 miles
          </option>
          <option value="150">
            Within 150 miles
          </option>
          <option value="250">
            Within 250 miles
          </option>
          <option value="500">
            Within 500 miles
          </option>
          <option value="12329">
            Any Distance
          </option>
        </select>
        <div
          v-if="formErrors.distance !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.distance[0] }}
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="formSubmitting"
      >
        <template v-if="formSubmitting">
          Updating
        </template>
        <template v-else>
          Update Personal Info
        </template>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'CustomizeFeedForm',
  data() {
    return {
      formSubmitting: false,
      formErrors: {},
      formFields: {},
    };
  },
  created() {
    this.formFields = {
      first_name: this.userData.first_name,
      last_name: this.userData.last_name,
      email: this.userData.email,
      zip_code: '',
      distance: '12329',
      bio: this.userData.bio,
    };
  },
  methods: {
    async submitForm() {
      this.formErrors = {};
      this.formSubmitting = true;

      const responseData = await this.api({
        url: `users/${this.userData.id}/`,
        method: 'PATCH',
        json: this.formFields,
      });

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.$store.commit('userData', responseData.body);
        this.$router.push('/');
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = {
          non_field_erros: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  width: 264px;
}
</style>
